import styled from 'styled-components'

interface ITabPanesContentContainerStyledProps {}

export const TabPanesContentContainerStyled = styled.div<ITabPanesContentContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: ${(props) => props.theme.space.medium} 0;
`
